module.exports = __webpack_public_path__ + "img/大图1.e2e4919b.jpg";